import { useCallback, useMemo } from 'react'
import useLog, { Log } from '../hooks/useLog'
import usePipelines, {
    AsyncPipelineStepFunction,
    Pipeline,
    Pipelines,
} from '../hooks/usePipelines'
import { nyuDataSchema } from '../../../shared/types'

const makeFetchUrl =
    (url: string): AsyncPipelineStepFunction =>
    (_lastResult: any, log: Log) => {
        log('fetching ' + url)
        return fetch(url)
    }

const parseJson: AsyncPipelineStepFunction = (response: Response) =>
    response.json()

const parseSchema: AsyncPipelineStepFunction = (data: any) =>
    Promise.resolve(nyuDataSchema.parse(data))

export default function useFetchPipeline(
    url: string
): ReturnType<typeof usePipelines> {
    const [log, clearLog] = useLog()

    const clearLogInPipeline: AsyncPipelineStepFunction = useCallback(
        (data) => {
            clearLog()
            return data
        },
        [clearLog]
    )

    const pipelines: Pipelines = useMemo<Pipelines>(() => {
        if (!url) {
            return []
        }
        const primaryPipeline: Pipeline = [
            [clearLogInPipeline, 'start'],
            [makeFetchUrl(url), 'load URL'],
            [parseJson, 'parse JSON'],
            [parseSchema, 'parse Schema'],
        ]

        return [primaryPipeline]
    }, [url, clearLogInPipeline])

    return usePipelines(pipelines, log)
}
